"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const Button_styles_1 = require("./Button.styles");
const Button = ({ className, onClick, disabled, type, buttonRef, tabIndex, ignoreTabIndex, dataAnalyticsId, children, ...restProps }) => {
    const handleClick = (event) => {
        event.preventDefault();
        if (onClick && !disabled) {
            onClick(event);
        }
        return null;
    };
    return (react_1.default.createElement(Button_styles_1.StyledButton, { className: className, onClick: onClick && handleClick, disabled: disabled, type: type || "button", ref: buttonRef, tabIndex: ignoreTabIndex ? -1 : tabIndex, "data-analytics-id": dataAnalyticsId, ...restProps }, children));
};
exports.Button = Button;
exports.Button.displayName = "Button";
//# sourceMappingURL=Button.js.map